export default __webpack_public_path__ + "static/char-thumb-56-5bd1b0be3a19e9876c0da7c78825a079.png";